import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ReferalService from "./../../api/referalService";

export const getReferalInfo = createAsyncThunk(
  "frontend/referral-info",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ReferalService.getReferalInfo();
      //
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const validateRefCode = createAsyncThunk(
  "frontend/validate-referral-code",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await ReferalService.validateRefCode(payload);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const getRefLeaderboard = createAsyncThunk(
  "frontend/referral-leaderboard",
  async ({ rejectWithValue }) => {
    try {
      const response = await ReferalService.getRefLeaderBoard();

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const initialState = {
  referalData: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
};

const salariesSlice = createSlice({
  name: "referalData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReferalInfo.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getReferalInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.referalData = action.payload.referalData || {};
        state.successMessage =
          action.payload.message || "Successfully fetched Referal info Data";
        state.errorMessage = "";
      })
      .addCase(getReferalInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(validateRefCode.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(validateRefCode.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.referalData = action.payload.referalData || {};
        state.successMessage =
          action.payload.message || "Successfully validated referal code ";
        state.errorMessage = "";
      })
      .addCase(validateRefCode.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getRefLeaderboard.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getRefLeaderboard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.referalData = action.payload.referalData || {};
        state.successMessage =
          action.payload.message ||
          "Successfully fetched Referal leaderboard Data";
        state.errorMessage = "";
      })
      .addCase(getRefLeaderboard.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      });
  },
});

export const { salariesDataAction, taxInputs } = salariesSlice.actions;

export default salariesSlice.reducer;
